import { render, staticRenderFns } from "./tab-education.vue?vue&type=template&id=182d33f5"
import script from "./tab-education.vue?vue&type=script&lang=js"
export * from "./tab-education.vue?vue&type=script&lang=js"
import style0 from "./tab-education.vue?vue&type=style&index=0&id=182d33f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports